export enum AppointmentType {
  Individual = 'Individual',
  Grouped = 'Grouped',
  Daycare = 'Daycare',
}
